const revitalizeInCountryOptions = () => {
    const revitalizeDealOptions = [
        { id: 'Not active', label: 'Not active' },
        { id: 'Active', label: 'Active' }
    ];
    return revitalizeDealOptions
}
const dealTypeOptions = () => {
    const dealTypeList = [
        { id: 'direct', label: 'Direct' },
        { id: 'indirect', label: 'Indirect' }
    ];
    return dealTypeList
}

const companyNameOptions = (customerList) => {
    const companyOptions = customerList.map(company => ({ id: company.orgId, label: company.companyName }));

    return companyOptions
}

const ctInitialQuotesOptions = (ctInitialQuotes) => {
    const quoteOptions = ctInitialQuotes.map(ctInitialQuote => ({ id: ctInitialQuote, label: ctInitialQuote }));
    return [...quoteOptions]
}

export default function createDealDetailColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];
    const { data = [] } = config;
    const { dealData, customerList, countryMappingList, ctInitialQuotes } = data;
    dealData.map((fieldData, rowIndex) => {

        let row = [];
        const rowId = config.tableType;

        config.columns.map((column, columnIndex) => {
            const columnId = column.id;
            const columnDataType = column.data.displayInBodyAs;
            let columnValue = null;
            let columnValueData = {};
            let isDisabled = false;

            if (columnDataType === "auto-complete") {
                let options = [];
                if (columnId === 'company') {
                    options = companyNameOptions(customerList);
                    columnValue = fieldData.company || "";
                }
                columnValueData = { ...column.data };
                columnValueData.options = options;
                columnValueData.defaultValue = columnValue;
                // customEventHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, rowIndex) : null;

            }
            if (columnDataType === "select") {
                if (columnId === "revitalizeDeal") {
                    columnValue = fieldData.revitalizeDeal || "";
                    columnValueData = { ...column.data };
                    columnValueData.options = revitalizeInCountryOptions();;
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "dealType") {
                    columnValue = fieldData.dealType || "";
                    columnValueData = { ...column.data };
                    columnValueData.options = dealTypeOptions();
                    columnValueData.defaultValue = columnValue;
                    isDisabled = fieldData.company ? false : true;
                }

            }
            else if (columnDataType === "multiselect") {
                if (columnId === "ctInitialQuote") {
                    const selectedValues = fieldData.ctInitialQuote || [];
                    columnValueData = { ...column.data };
                    columnValueData.options = ctInitialQuotesOptions(ctInitialQuotes);
                    columnValueData.defaultValue = selectedValues;
                }
            }
            else if (columnDataType === "input") {
                if (columnId === 'dealId') {
                    columnValue = fieldData.dealId;
                }
                // else if (columnId === 'company') {
                //     columnValue = fieldData.company;
                // }
                else if (columnId === 'orgId') {
                    columnValue = fieldData.orgId;
                    isDisabled = true;
                }
                else if (columnId === 'dealExpirationDate') {
                    columnValue = fieldData.dealExpirationDate;
                    columnValueData.disableBeforeDates = [fieldData.dealStartDate];
                    if (!fieldData.dealStartDate) {
                        isDisabled = true;
                    }
                }
                else if (columnId === 'dealStartDate') {
                    columnValue = fieldData.dealStartDate;
                }
                else if (columnId === 'salesContactEmailAddress') {
                    columnValue = fieldData.salesContactEmailAddress;
                }
                columnValueData = { defaultValue: columnValue, ...column.data, ...columnValueData };
            }

            row.push({
                [columnId]: {
                    id: columnId + "|" + rowId + "!" + rowIndex + "" + columnIndex,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValueData,
                    width: column.width,
                    disabled: isDisabled,
                    displayAsIs: column.data.displayInBodyAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: column.data.highlightBodyText,
                    clickHandler: (event, value, inputType) => config.bodyButtonsHandler(event, columnId, value, inputType)
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });

    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}
